// Shared shell state (global shell + ACS lot, 13/10): two explicit registries the dock reads, fed by the screens and layers
// themselves (no DOM polling, no MutationObserver, no second focus engine; the vendored dialog engine stays the modal guard).
// · immersive: a focused view is on screen (guided séance, onboarding, initial bilan, bilan form, full message thread)
//   → the dock is not rendered as navigation there (hidden + inert) and the page gets its own bottom room back.
// · modal: a modal layer is open (bell drawer, custom / account sheets, mobile avatar sheet, fullscreen MediaViewer)
//   → the dock is hidden and inert while it is open, and comes back when the last one closes.
// Counted, so nested layers and StrictMode double effects stay balanced.
import { useEffect, useSyncExternalStore } from "react";

let immersive = 0, modal = 0, version = 0;
const listeners = new Set<() => void>();
const bump = () => { version++; listeners.forEach(l => l()); };
const subscribe = (l: () => void) => { listeners.add(l); return () => listeners.delete(l); };

/** Registers `on` as an immersive view for as long as the calling component shows it. */
export function useShellImmersive(on: boolean) {
  useEffect(() => { if (!on) return; immersive++; bump(); return () => { immersive--; bump(); }; }, [on]);
}
/** Registers an open modal layer (open state from the layer's own open / onOpenChange, or its mount). */
export function useShellModal(open: boolean) {
  useEffect(() => { if (!open) return; modal++; bump(); return () => { modal--; bump(); }; }, [open]);
}
export function useShellState() {
  useSyncExternalStore(subscribe, () => version, () => version);
  return { immersive: immersive > 0, modal: modal > 0 };
}
